import { strings } from "../../strings/strings";

function LogoutModel(props) {
  const { handleConfirmLogOut, handleCancelLogout } = props;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
        <h2 className="text-lg font-semibold  mb-4">{strings.confirmLogoutTitle}</h2>
        <p className="text-sm  mb-6">{strings.areyousureyouwanttologout}</p>
        <div className="flex justify-end gap-3">
          <button onClick={handleConfirmLogOut} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            {strings.ok}
          </button>
          <button onClick={handleCancelLogout} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
            {strings.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogoutModel;
